// Make it easy to retrieve a set cookie:

export const getCookieByName = (name: string): string | null => {
  if (!document.cookie) return null

  return document.cookie
    .split(';')
    .map((cookie) => cookie.trim().split('='))
    .filter(([cookieName]) => cookieName === name)
    .map(([, value]) => value)[0]
}

export const setCookie = (
  name: string,
  value: string,
  maxAgeDays: number = 30,
) => {
  const maxAge = maxAgeDays * 24 * 60 * 60
  document.cookie = `${name}=${value}; path=/; max-age=${maxAge}; SameSite=Lax`
}
